// src/app/lazyRoutes.ts
/**
 * Every code-split route/view/modal used by AuthedApp.
 *
 * Extracted from AuthedApp.tsx (plans/monolith-migration-plan.md §11.12, Batch 4).
 * These are pure `lazyWithRetry(() => import(...))` declarations — no logic, no state.
 * The explanatory comments travel with the declarations they describe.
 */

import { lazyWithRetry } from "../lib/lazyWithRetry";
export const ExplorerView = lazyWithRetry(() => import("../views/ExplorerView"));
export const TracesView = lazyWithRetry(() => import("../features/traces"));
export const HandoverView = lazyWithRetry(() => import("../features/handover"));
export const HRView = lazyWithRetry(() => import("../views/HRView"));
export const ReservationsView = lazyWithRetry(() => import("../views/ReservationsView"));
export const ReservationsRoute = lazyWithRetry(() => import("../features/reservations/ReservationsRoute"));
export const RoomRackView = lazyWithRetry(() => import("../features/room-rack"));
export const AvailabilityView = lazyWithRetry(() => import("../features/availability"));
export const AnalyticsView = lazyWithRetry(() => import("../views/AnalyticsView"));
export const HousekeepingView = lazyWithRetry(() => import("../views/HousekeepingView"));
export const SalesView = lazyWithRetry(() => import("../views/SalesView"));
export const FundsachenView = lazyWithRetry(() => import("../features/fundsachen"));
export const HaustechnikView = lazyWithRetry(() => import("../features/haustechnik"));
export const InternalResourcesView = lazyWithRetry(() => import("../features/internal-resources"));
export const InventoryView = lazyWithRetry(() => import("../features/inventory"));
export const KassenbuchView = lazyWithRetry(() => import("../features/kassenbuch"));
export const BuchhaltungView = lazyWithRetry(() => import("../views/BuchhaltungView"));
export const XRechnungView = lazyWithRetry(() => import("../views/XRechnungView"));
export const AnleitungenView = lazyWithRetry(() => import("../views/AnleitungenView"));
export const GroupsView = lazyWithRetry(() => import("../views/GroupsView"));
export const OffersView = lazyWithRetry(() => import("../views/OffersView"));
export const AdminDashboardView = lazyWithRetry(() => import("../features/admin-dashboard"));
export const AutomationsView = lazyWithRetry(() => import("../views/AutomationsView"));
export const WorkflowsView = lazyWithRetry(() => import("../views/WorkflowsView"));
export const ChatView = lazyWithRetry(() => import("../features/chat"));
export const DashboardView = lazyWithRetry(() => import("../views/DashboardView"));
// Code-split the 4 shell-level modals/views that used to be statically
// imported. Each one returns null while closed (PatchNotesModal /
// UserProfilePreferencesModal / SupportTicketModal guard on `!isOpen`;
// UsersView is a route element inside the same Suspense boundary as every
// other lazy view) — so rendering the lazy component inside Suspense is safe:
// before the chunk resolves the modal simply renders nothing, and the chunk
// loads on first open/first navigation. Same pattern as the lazy route views
// above; see the useChatUnread split-import comment for the import-side
// rationale.
export const PatchNotesModal = lazyWithRetry(() => import("../PatchNotesModal"));
export const UserProfilePreferencesModal = lazyWithRetry(() => import("../components/UserProfilePreferencesModal"));
export const UsersView = lazyWithRetry(() => import("../components/UsersView"));
export const SupportTicketModal = lazyWithRetry(() => import("../components/SupportTicketModal"));
// Global in-app attachment viewer — consumes uiStore.fileViewer, which every
// openStorageFile() call populates. Lazy like the other shell modals so the
// main chunk stays lean (bundle-budget gate).
export const FileViewerModal = lazyWithRetry(() => import("../components/FileViewerModal"));
